<template>
  <div ref="chartContainer" class="force-chart-container" :style="{ width: width, height: height }"></div>
</template>

<script>
import echarts from './echarts-config.js';

export default {
  name: 'ForceRelationChart',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    nodes: {
      type: Array,
      default: () => []
    },
    links: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chart: null,
      defaultOption: {
        title: {
          text: 'AI知识星图',
          left: 'center'
        },
        tooltip: {
          formatter: '{b}'
        },
        toolbox: {
          feature: {
            // restore: {},
            // saveAsImage: {}
          }
        },
        animationDurationUpdate: 1500,
        animationEasing: 'cubicIn',
        animationEasingUpdate: 'cubicIn',
        series: [{
          type: 'graph',
          layout: 'force',
          emphasis: {
            disabled: false
          },
          force: {
            repulsion: 300,
            edgeLength: [10, 50],
            gravity: 0.1,
            initLayout: 'circular',
          },
          roam: true,
          label: {
            show: true,
            position: 'right',
            formatter: '{b}',
            // 根据节点层级设置不同的字体样式
            rich: {
              // 中心节点样式
              center: {
                fontSize: 18,
                fontWeight: 'bold',
                color: '#333'
              },
              // 第一层节点样式
              level1: {
                fontSize: 16,
                fontWeight: 'bold',
                color: '#333'
              },
              // 第二层节点样式
              level2: {
                fontSize: 12,
                fontWeight: 'normal',
                color: '#666'
              },
              // 第三层节点样式
              level3: {
                fontSize: 10,
                fontWeight: 'normal',
                color: '#999'
              }
            },
            // 动态设置字体样式
            emphasis: {
              fontSize: 16,
              fontWeight: 'bold'
            }
          },
          draggable: true,
          lineStyle: {
            color: 'source',
            curveness: 0.3
          },
          emphasis: {
            focus: 'adjacency',
            lineStyle: {
              width: 4
            }
          },
          data: [],
          links: []
        }]
      }
    };
  },
  watch: {
    nodes: {
      handler() {
        this.updateChart();
      },
      deep: true
    },
    links: {
      handler() {
        this.updateChart();
      },
      deep: true
    },
    config: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer);
      this.updateChart();
    },
    updateChart() {
      if (!this.chart) return;
      console.log('Updating chart with nodes:', this.nodes);

      // 处理节点数据，根据层级设置不同的标签样式
      const processedNodes = this.nodes.length > 0 ? this.nodes.map(node => {
        // 根据symbolSize和节点名称判断层级
        let labelStyle = {};

        if (node.name === '医药云课堂') {
          // 中心节点
          labelStyle = {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#333'
          };
        } else if (node.symbolSize >= 25) {
          // 第一层节点（部门）
          labelStyle = {
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333'
          };
        } else if (node.symbolSize >= 20) {
          // 第二层节点（分类名称）
          labelStyle = {
            fontSize: 12,
            fontWeight: 'normal',
            color: '#666'
          };
        } else {
          // 第三层节点（用户名称）
          labelStyle = {
            fontSize: 11,
            fontWeight: 'normal',
            color: '#999'
          };
        }

        return {
          ...node,
          label: {
            ...node.label,
            ...labelStyle,
            show: true,
            position: 'right',
            formatter: '{b}'
          }
        };
      }) : this.getMockNodes();

      const option = {
        ...this.defaultOption,
        ...this.config,
        series: [{
          ...this.defaultOption.series[0],
          ...(this.config.series?.[0] || {}),
          data: processedNodes,
          links: this.links.length > 0 ? this.links : this.getMockLinks()
        }]
      };

      this.chart.setOption(option);
    },
    // 提供默认的模拟数据
    getMockNodes() {
      return [
        {},
      ];
    },
    getMockLinks() {
      return [
        {},
      ];
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>

<style scoped>
.force-chart-container {
  min-width: 300px;
  min-height: 400px;
}
</style>